import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { Subject, switchMap, tap } from 'rxjs';
import { AuthService } from '../../../services/auth/auth.service';
import {
  SignInFormComponent,
  SignInRequest,
} from '../sign-in-form/sign-in-form.component';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatProgressSpinner,
    RouterLink,
    SignInFormComponent,
  ],
})
export class SignInComponent {
  private readonly authService = inject(AuthService);

  protected readonly spinner = signal(false);

  private readonly signInRequest$ = new Subject<SignInRequest>();

  protected readonly signInResponse = toSignal(
    this.signInRequest$.pipe(
      tap(() => this.spinner.set(true)),
      switchMap((req) =>
        this.authService.signInWithEmailAndPassword(req.email, req.password),
      ),
      tap(() => this.spinner.set(false)),
    ),
  );

  protected handleRequest(request: SignInRequest): void {
    this.signInRequest$.next(request);
  }
}
